import api from './api';

const supplierReportsService = {
  // Get supplier reports data
  getSupplierReports: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.supplierId) queryParams.append('supplierId', params.supplierId);
      if (params.category) queryParams.append('category', params.category);

      const queryString = queryParams.toString();
      const url = `/supplier-reports/reports${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching supplier reports:', error);
      throw error;
    }
  },

  // Get filter options
  getSupplierFilterOptions: async () => {
    try {
      const response = await api.get('/supplier-reports/filters');
      return response.data;
    } catch (error) {
      console.error('Error fetching filter options:', error);
      throw error;
    }
  }
};

export default supplierReportsService;

